<header id="header">
  <div class="container">
    <div id="header-logo" class="header-logo">
      <a routerLink="/"><img src="/assets/images/global/logo.png"/></a>
    </div>
  </div>
</header>
